import { Component, OnInit, Directive, Input, HostListener, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { ReportsService } from '../../../../shared/services/reports.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../../../../environments/environment';
import { Chart } from 'chart.js';
import { MatDialog, MatDialogRef, MatSnackBar, MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'case-type-reports',
  templateUrl: './case.type.reports.html'
})
export class CaseTypeReportsComponent implements OnInit {


  @ViewChild('caseTypeTable') caseTypeTable: any;

  displayedColumns: string[] = ['case_number', 'created_date','modified_date', 'type'];
  @Input() userAttributes: Subject<any>;
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
        this.tableData.paginator = paginator;
  }


  view: any[] = [null, 400];

  showTable = false;

  loading = true;

  caseTypeReportsChartData = [];

  caseTypeReports = {};

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  explodeSlices = false;

  tableData = new MatTableDataSource<any>();

  token: string;
  orgId = null;
  userId = null;

  chartLabel = [];

  chartData = [];
  chartColors = [];

  error: string;

  color = ['#49AFD9', '#A6D8E7', '#C1CDD4', '#798893', '#00B7D6', '#00ffff', '#40ff00', '#ff4000', '#0065AB', '#ffff00', '#e60000', '#ff00ff', '#000099', '#ff66d9', '#ff9933', '#33ff33', '#ff6633', '#b30000'];

  constructor(
    private reportsService: ReportsService,
    private router: Router,
    private cognito: CognitoUtil,
    private localUser: LocalUserService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,

  ) {

  }

  ngOnInit() {
    this.orgId = this.localUser.getOrganizationId();
    this.userId = this.localUser.getUserId();
    this.getCaseTypeReports();
  }

  toolTipGenerator = function (event) {
    let text;
    if (event && event.data) {
      text = `${event.data.name} - ${event.data.value}`;
    }
    return text;
  };

  onPieSectorClick(event, tableData, reportsData) {
    this[tableData] = reportsData[event.name];
    this.showTable = true;
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  getCaseTypeReports() {
    this.reportsService.getCaseTypeReports(this.orgId, this.userId)
      .subscribe((data) => {

        let keys = Object.keys(data);
        let formedData = [];

        for (let i = 0; i < keys.length; i++) {
          let newObject = {
            name: keys[i],
            value: data[keys[i]]
          };
          formedData.push(newObject);
        }

        this.caseTypeReportsChartData = formedData;
        let index = 0;
        this.caseTypeReportsChartData.forEach(item => {
          this.chartLabel.push(item.name);
          this.chartData.push(item.value);
          // this.chartColors.push(this.dynamicColors());
          this.chartColors.push(this.color[index]);
          index = index + 1;
        });
        this.loading = false;
        this.barChart();
      }, error => {
        this.loading = false;
        this.error = 'Server Not Responding';
        this.snackBar.open(this.error, '', {
          duration: 2000,
        });
      });


  }

  barChart() {
    $('#caseType').remove();
    $('#parentType').append('<canvas id="caseType"></canvas>');
    var ctx = document.getElementById("caseType");
    new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.chartLabel,
        datasets: [
          {
            label: "",
            backgroundColor: this.chartColors,
            data: this.chartData
          }
        ]
      },
      options: {
        onClick: (mouseEvent, chart) => {
          let index = chart[0]._index
          let type = this.chartLabel[index]
          this.onCaseTypeSectorSelect(type)
        },
        legend: { display: true },
        title: {
          display: true,
          text: 'Case Type'
        }
      }
    });


  }

  onCaseTypeSectorSelect(event) {
    this.loading = true;
    this.reportsService.getReportsCases(this.orgId, this.userId, 'CaseType', event)
      .subscribe(result => {
        this.tableData.data = result;
        this.showTable = true;
        this.loading = false;
      }, error => {
        this.loading = false;
        this.error = 'Server Not Responding';
        this.snackBar.open(this.error, '', {
          duration: 2000,
        });
      });
  }

  toggleExpandRow(row, tableType) {
    this[tableType].rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
  }

  openCase(row) {
    this.router.navigate(['case', row.caseSummary.organization_id, row.id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/case-type/case.type.reports.ts